import React from 'react';

interface MetricCardProps {
  label: string;
  value: string | number | null | undefined;
  source?: string; // deprecated: no longer rendered (kept so call sites compile)
  icon?: React.ReactNode;
  trend?: string;
  subtext?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  icon,
  trend,
  subtext,
}) => {
  const displayValue = value !== null && value !== undefined && value !== '' ? value : '—';

  return (
    <div className="kpi-card">
      <div className="kpi-label">
        <span>{label}</span>
        {icon && <span style={{ color: 'var(--primary-light)' }}>{icon}</span>}
      </div>
      <div className="kpi-value">{displayValue}</div>
      {trend && (
        <div style={{ fontSize: '11px', marginTop: '4px', color: 'var(--success-text)' }}>
          {trend}
        </div>
      )}
      {subtext && (
        <div style={{ fontSize: '11px', marginTop: '2px', color: 'var(--text-muted)' }}>
          {subtext}
        </div>
      )}
    </div>
  );
};
